import React, { useState } from 'react';
import { Box, Card, TextField, Button, Typography, Container, Alert, CircularProgress } from '@mui/material';
import { Link, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

export default function VerifyOtp() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { isLoading, error } = useSelector((state) => state.auth);

    const [searchParams] = useSearchParams();
    
    const initialEmail = location.state?.email || searchParams.get('email') || '';
    const [email, setEmail] = useState(initialEmail);
    const [otp, setOtp] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            dispatch.auth.setError('Please enter your email address.');
            return;
        }

        const result = await dispatch.auth.verifyOtpAsync({ email, otp });
        if (result?.success) {
            if (result.token) {
                navigate('/reset-password', { state: { token: result.token } });
            } else {
                dispatch.auth.setError('Verification successful but no reset token received.');
            }
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', bgcolor: 'primary.dark' }}>
            <Container maxWidth="xs">
                <Card sx={{ p: 4, borderRadius: 3, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
                    <Box sx={{ textAlign: 'center', mb: 3 }}>
                        <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
                            Verify OTP
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Enter the 6-digit verification code sent to your email.
                        </Typography>
                    </Box>

                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    
                    <form onSubmit={handleSubmit}>
                        {!initialEmail && (
                            <TextField
                                fullWidth
                                label="Email Address"
                                variant="outlined"
                                margin="normal"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                            />
                        )}
                        <TextField
                            fullWidth
                            label="OTP Code"
                            variant="outlined"
                            margin="normal"
                            required
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            inputProps={{ maxLength: 6, style: { textAlign: 'center', letterSpacing: '8px', fontSize: '1.5rem' } }}
                            autoFocus={!!initialEmail}
                        />
                        <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            size="large"
                            color="primary"
                            disabled={isLoading || otp.length < 6 || !email}
                            sx={{ mt: 2 }}
                        >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Verify OTP'}
                        </Button>
                    </form>

                    <Box sx={{ textAlign: 'center', mt: 3 }}>
                        <Typography variant="body2">
                            Didn't receive the code?{' '}
                            <Link to="/forgot-password" style={{ color: '#4f46e5', textDecoration: 'none' }}>
                                Resend
                            </Link>
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            <Link to="/login" style={{ color: '#4f46e5', textDecoration: 'none' }}>
                                Back to Login
                            </Link>
                        </Typography>
                    </Box>
                </Card>
            </Container>
        </Box>
    );
}
